import { decryptId } from "../../../Components/CryptoComponent";
import AddLookup from "../../../Components/InputComponents/AddLookup";
import { useParams, useSearchParams } from "react-router-dom";

function EditCompanyType() {
  const { id } = useParams();
  const decryptedId = decryptId(decodeURIComponent(id));

  const [searchParams] = useSearchParams();
  const redirectURL = `/CompanyTypeLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Edit Company Type"
      alert="Company Type Edited Successfully"
      editDataAPIEndPoint={`/CompanyType/Edit/${decryptedId}`}
      viewDataDetailsAPIEndPoint={`/CompanyType/listbyId/${decryptedId}`}
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Company Type",
              name: "CT_Name",
              required: true, // Validation rule added here
               maxLength:70
            },
            {
              type: "select",
              label: "Status",
              name: "CT_Status",
              required: true, // Validation rule added here
                            options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        CT_Name: {
          required: true,
          
        },
        CT_Status: {
          required: true,
        },
      }}
    />
  );
}

export default EditCompanyType;
